{
  "$schema": "./strings.schema.json",
  "$table": "strings-b11.json",
  "$dialect": "B-11 dialect (office two doors left)",
  "$generatedBy": "decoys/generate.mjs",
  "$note": "generated translation dump. the dump wins; hand edits are swept.",
  "entries": {
    "comments.title": "Comments",
    "comments.empty": "No entries. Consider writing one.",
    "comments.post": "Post comment",
    "comments.placeholder": "Say something the desk can defend.",
    "comments.pending": "Held for moderation. Both of them.",
    "comments.disabled": "Comments are closed on this story. It is happier this way.",
    "comments.moderated": "A moderator read this. The moderator is fine.",
    "comment.reply": "Reply",
    "comment.report": "Report to universe of origin",
    "comment.like": "Duly noted",
    "comments.policy": "House rules: be kind, be legible, be from somewhere.",
    "reader.welcome": "The paper remembers you fondly.",
    "reader.farewell": "Synchronized across the corridor.",
    "error.generic": "This did not work. It did not work politely.",
    "nav.front": "Front page",
    "nav.editions": "Editions",
    "nav.archive": "Archive",
    "nav.signup": "Sign up",
    "footer.line": "Parallel Tidings — B-11 edition",
    "footer.rights": "All rights reserved, in this universe only.",
    "ui.cta.v1": "Open edition",
    "ui.cta.v2": "Open",
    "ui.cta.v3": "Unfold",
    "ui.cta.v4": "Go on",
    "ui.cta.v5": "Keep reading",
    "ui.cta.v6": "Look inside",
    "ui.cta.v7": "Open edition",
    "ui.cta.v8": "View page",
    "ui.cta.v9": "Go on",
    "ui.cta.v10": "Read",
    "ui.cta.v11": "Keep reading",
    "ui.cta.v12": "Read",
    "ui.cta.v13": "Unfold",
    "ui.cta.v14": "Open edition",
    "ui.cta.v15": "Open edition",
    "ui.cta.v16": "See more",
    "ui.cta.v17": "Read",
    "ui.cta.v18": "View page",
    "ui.cta.v19": "Continue",
    "ui.cta.v20": "Read",
    "ui.cta.v21": "Keep reading",
    "ui.cta.v22": "Open",
    "ui.cta.v23": "View page",
    "ui.cta.v24": "View page",
    "ui.cta.v25": "Continue",
    "ui.cta.v26": "See more",
    "ui.cta.v27": "Open edition",
    "ui.cta.v28": "Go on",
    "ui.cta.v29": "Go on",
    "ui.cta.v30": "Continue",
    "ui.cta.v31": "Keep reading",
    "ui.cta.v32": "Open",
    "ui.cta.v33": "Unfold",
    "ui.cta.v34": "See more",
    "ui.cta.v35": "See more",
    "ui.cta.v36": "Unfold",
    "ui.cta.v37": "Open edition",
    "ui.cta.v38": "View page",
    "ui.cta.v39": "Go on",
    "ui.cta.v40": "Read",
    "ui.cta.v41": "Keep reading",
    "ui.cta.v42": "Open",
    "ui.cta.v43": "See more",
    "ui.cta.v44": "Read",
    "ui.cta.v45": "Continue",
    "ui.cta.v46": "Continue",
    "ui.cta.v47": "Open edition",
    "ui.cta.v48": "Look inside",
    "ui.cta.v49": "Open edition",
    "ui.cta.v50": "Read",
    "ui.cta.v51": "Open edition",
    "ui.cta.v52": "Open",
    "ui.cta.v53": "Unfold",
    "ui.cta.v54": "See more",
    "ui.cta.v55": "See more",
    "ui.cta.v56": "Look inside",
    "ui.cta.v57": "Look inside",
    "ui.cta.v58": "Open",
    "ui.cta.v59": "Go on",
    "ui.cta.v60": "Read",
    "ui.cta.v61": "View page",
    "ui.cta.v62": "Open",
    "ui.cta.v63": "Look inside",
    "ui.cta.v64": "Continue",
    "ui.cta.v65": "Continue",
    "ui.cta.v66": "Look inside",
    "ui.cta.v67": "Open edition",
    "ui.cta.v68": "Look inside",
    "ui.cta.v69": "Go on",
    "ui.cta.v70": "Read",
    "ui.cta.v71": "Keep reading",
    "ui.cta.v72": "See more",
    "ui.cta.v73": "Unfold",
    "ui.cta.v74": "Look inside",
    "ui.cta.v75": "See more",
    "ui.cta.v76": "Look inside",
    "ui.cta.v77": "Open edition",
    "ui.cta.v78": "View page",
    "ui.cta.v79": "Unfold",
    "ui.cta.v80": "View page",
    "ui.cta.v81": "Keep reading",
    "ui.cta.v82": "Open",
    "ui.cta.v83": "Unfold",
    "ui.cta.v84": "Continue",
    "ui.cta.v85": "See more",
    "ui.cta.v86": "Read",
    "ui.cta.v87": "Open edition",
    "ui.cta.v88": "Open",
    "ui.cta.v89": "Go on",
    "ui.cta.v90": "Open",
    "ui.cta.v91": "Keep reading",
    "ui.cta.v92": "Open",
    "ui.cta.v93": "Unfold",
    "ui.cta.v94": "Continue",
    "ui.cta.v95": "See more",
    "ui.cta.v96": "Look inside",
    "ui.cta.v97": "Read",
    "ui.cta.v98": "View page",
    "ui.cta.v99": "Go on",
    "ui.cta.v100": "Read",
    "ui.cta.v101": "Go on",
    "ui.cta.v102": "Open",
    "ui.cta.v103": "See more",
    "ui.cta.v104": "Go on",
    "ui.cta.v105": "Open edition",
    "ui.cta.v106": "Look inside",
    "ui.cta.v107": "Unfold",
    "ui.cta.v108": "Read",
    "ui.cta.v109": "Open edition",
    "ui.cta.v110": "Read",
    "ui.cta.v111": "Open",
    "ui.cta.v112": "Open",
    "ui.cta.v113": "Keep reading",
    "ui.cta.v114": "Read",
    "ui.cta.v115": "Look inside",
    "ui.cta.v116": "Look inside",
    "ui.cta.v117": "Open edition",
    "ui.cta.v118": "See more",
    "ui.cta.v119": "Go on",
    "ui.cta.v120": "Read",
    "ui.cta.v121": "Go on",
    "ui.cta.v122": "Open",
    "ui.cta.v123": "Unfold",
    "ui.cta.v124": "See more",
    "ui.cta.v125": "See more",
    "ui.cta.v126": "Look inside",
    "ui.cta.v127": "Open",
    "ui.cta.v128": "View page",
    "ui.cta.v129": "Go on",
    "ui.cta.v130": "Unfold",
    "ui.cta.v131": "Open edition",
    "ui.cta.v132": "Open",
    "ui.cta.v133": "Open",
    "ui.cta.v134": "Continue",
    "ui.cta.v135": "See more",
    "ui.toast.v1": "Noted, in the margin.",
    "ui.toast.v2": "Filed under patience.",
    "ui.toast.v3": "Synchronized across the corridor.",
    "ui.toast.v4": "Delivered to your universe of record.",
    "ui.toast.v5": "Held for editorial review.",
    "ui.toast.v6": "Printed to the archive of intentions.",
    "ui.toast.v7": "Sent. The desk saw it leave.",
    "ui.toast.v8": "Printed to the archive of intentions.",
    "ui.toast.v9": "Synchronized across the corridor.",
    "ui.toast.v10": "Set in ink, provisionally.",
    "ui.toast.v11": "Understood. Not acted on. Yet.",
    "ui.toast.v12": "Synchronized across the corridor.",
    "ui.toast.v13": "Drafted, with feeling.",
    "ui.toast.v14": "Synchronized across the corridor.",
    "ui.toast.v15": "Saved. Somewhere.",
    "ui.toast.v16": "Held for editorial review.",
    "ui.toast.v17": "Held for editorial review.",
    "ui.toast.v18": "Queued behind two universes.",
    "ui.toast.v19": "Set in ink, provisionally.",
    "ui.toast.v20": "Queued behind two universes.",
    "ui.toast.v21": "Filed under patience.",
    "ui.toast.v22": "Delivered to your universe of record.",
    "ui.toast.v23": "Synchronized across the corridor.",
    "ui.toast.v24": "Saved. Somewhere.",
    "ui.toast.v25": "Understood. Not acted on. Yet.",
    "ui.toast.v26": "Filed under patience.",
    "ui.toast.v27": "Filed under patience.",
    "ui.toast.v28": "Queued behind two universes.",
    "ui.toast.v29": "Saved. Somewhere.",
    "ui.toast.v30": "Printed to the archive of intentions.",
    "ui.toast.v31": "Filed under patience.",
    "ui.toast.v32": "Drafted, with feeling.",
    "ui.toast.v33": "Synchronized across the corridor.",
    "ui.toast.v34": "Held for editorial review.",
    "ui.toast.v35": "Understood. Not acted on. Yet.",
    "ui.toast.v36": "Drafted, with feeling.",
    "ui.toast.v37": "Saved. Somewhere.",
    "ui.toast.v38": "Sent. The desk saw it leave.",
    "ui.toast.v39": "Understood. Not acted on. Yet.",
    "ui.toast.v40": "Synchronized across the corridor.",
    "ui.toast.v41": "Noted, in the margin.",
    "ui.toast.v42": "Queued behind two universes.",
    "ui.toast.v43": "Sent. The desk saw it leave.",
    "ui.toast.v44": "Set in ink, provisionally.",
    "ui.toast.v45": "Synchronized across the corridor.",
    "ui.toast.v46": "Saved. Somewhere.",
    "ui.toast.v47": "Drafted, with feeling.",
    "ui.toast.v48": "Saved. Somewhere.",
    "ui.toast.v49": "Noted, in the margin.",
    "ui.toast.v50": "Understood. Not acted on. Yet.",
    "ui.toast.v51": "Sent. The desk saw it leave.",
    "ui.toast.v52": "Printed to the archive of intentions.",
    "ui.toast.v53": "Held for editorial review.",
    "ui.toast.v54": "Queued behind two universes.",
    "ui.toast.v55": "Sent. The desk saw it leave.",
    "ui.toast.v56": "Drafted, with feeling.",
    "ui.toast.v57": "Understood. Not acted on. Yet.",
    "ui.toast.v58": "Set in ink, provisionally.",
    "ui.toast.v59": "Understood. Not acted on. Yet.",
    "ui.toast.v60": "Delivered to your universe of record.",
    "ui.toast.v61": "Queued behind two universes.",
    "ui.toast.v62": "Filed under patience.",
    "ui.toast.v63": "Queued behind two universes.",
    "ui.toast.v64": "Printed to the archive of intentions.",
    "ui.toast.v65": "Held for editorial review.",
    "ui.toast.v66": "Queued behind two universes.",
    "ui.toast.v67": "Sent. The desk saw it leave.",
    "ui.toast.v68": "Held for editorial review.",
    "ui.toast.v69": "Drafted, with feeling.",
    "ui.toast.v70": "Noted, in the margin.",
    "ui.toast.v71": "Set in ink, provisionally.",
    "ui.toast.v72": "Held for editorial review.",
    "ui.toast.v73": "Noted, in the margin.",
    "ui.toast.v74": "Understood. Not acted on. Yet.",
    "ui.toast.v75": "Printed to the archive of intentions.",
    "ui.toast.v76": "Held for editorial review.",
    "ui.toast.v77": "Synchronized across the corridor.",
    "ui.toast.v78": "Noted, in the margin.",
    "ui.toast.v79": "Sent. The desk saw it leave.",
    "ui.toast.v80": "Understood. Not acted on. Yet.",
    "ui.toast.v81": "Queued behind two universes.",
    "ui.toast.v82": "Held for editorial review.",
    "ui.toast.v83": "Held for editorial review.",
    "ui.toast.v84": "Understood. Not acted on. Yet.",
    "ui.toast.v85": "Noted, in the margin.",
    "ui.toast.v86": "Delivered to your universe of record.",
    "ui.toast.v87": "Held for editorial review.",
    "ui.toast.v88": "Synchronized across the corridor.",
    "ui.toast.v89": "Saved. Somewhere.",
    "ui.toast.v90": "Sent. The desk saw it leave.",
    "ui.toast.v91": "Synchronized across the corridor.",
    "ui.toast.v92": "Drafted, with feeling.",
    "ui.toast.v93": "Queued behind two universes.",
    "ui.toast.v94": "Set in ink, provisionally.",
    "ui.toast.v95": "Filed under patience.",
    "ui.toast.v96": "Saved. Somewhere.",
    "ui.toast.v97": "Noted, in the margin.",
    "ui.toast.v98": "Filed under patience.",
    "ui.toast.v99": "Set in ink, provisionally.",
    "ui.toast.v100": "Delivered to your universe of record.",
    "ui.toast.v101": "Held for editorial review.",
    "ui.toast.v102": "Queued behind two universes.",
    "ui.toast.v103": "Sent. The desk saw it leave.",
    "ui.toast.v104": "Drafted, with feeling.",
    "ui.toast.v105": "Synchronized across the corridor.",
    "ui.toast.v106": "Set in ink, provisionally.",
    "ui.toast.v107": "Understood. Not acted on. Yet.",
    "ui.toast.v108": "Saved. Somewhere.",
    "ui.toast.v109": "Noted, in the margin.",
    "ui.toast.v110": "Held for editorial review.",
    "ui.toast.v111": "Queued behind two universes.",
    "ui.toast.v112": "Delivered to your universe of record.",
    "ui.toast.v113": "Held for editorial review.",
    "ui.toast.v114": "Queued behind two universes.",
    "ui.toast.v115": "Sent. The desk saw it leave.",
    "ui.toast.v116": "Drafted, with feeling.",
    "ui.toast.v117": "Synchronized across the corridor.",
    "ui.toast.v118": "Set in ink, provisionally.",
    "ui.toast.v119": "Held for editorial review.",
    "ui.toast.v120": "Held for editorial review.",
    "ui.toast.v121": "Filed under patience.",
    "ui.toast.v122": "Filed under patience.",
    "ui.toast.v123": "Printed to the archive of intentions.",
    "ui.toast.v124": "Printed to the archive of intentions.",
    "ui.toast.v125": "Printed to the archive of intentions.",
    "ui.toast.v126": "Queued behind two universes.",
    "ui.toast.v127": "Sent. The desk saw it leave.",
    "ui.toast.v128": "Sent. The desk saw it leave.",
    "ui.toast.v129": "Held for editorial review.",
    "ui.toast.v130": "Filed under patience.",
    "ui.toast.v131": "Delivered to your universe of record.",
    "ui.toast.v132": "Saved. Somewhere.",
    "ui.toast.v133": "Noted, in the margin.",
    "ui.toast.v134": "Held for editorial review.",
    "ui.toast.v135": "Queued behind two universes.",
    "greeting.formal.v1": "Good day. It is a news day.",
    "greeting.formal.v2": "Your universe of record stands confirmed.",
    "greeting.formal.v3": "Your universe of record stands confirmed.",
    "greeting.formal.v4": "Your universe of record stands confirmed.",
    "greeting.formal.v5": "You are receiving this correctly.",
    "greeting.formal.v6": "Good day. It is a news day.",
    "greeting.formal.v7": "Your universe of record stands confirmed.",
    "greeting.formal.v8": "We read you with both eyes open.",
    "greeting.formal.v9": "Your universe of record stands confirmed.",
    "greeting.formal.v10": "You are among readers.",
    "greeting.formal.v11": "Welcome back, presumably.",
    "greeting.formal.v12": "The desk acknowledges you.",
    "greeting.formal.v13": "The paper remembers you fondly.",
    "greeting.formal.v14": "You are receiving this correctly.",
    "greeting.formal.v15": "You are receiving this correctly.",
    "greeting.formal.v16": "You are receiving this correctly.",
    "greeting.formal.v17": "You are receiving this correctly.",
    "greeting.formal.v18": "We read you with both eyes open.",
    "greeting.formal.v19": "Welcome back, presumably.",
    "greeting.formal.v20": "The paper remembers you fondly.",
    "greeting.formal.v21": "You are receiving this correctly.",
    "greeting.formal.v22": "You are receiving this correctly.",
    "greeting.formal.v23": "You are among readers.",
    "greeting.formal.v24": "We read you with both eyes open.",
    "greeting.formal.v25": "The desk acknowledges you.",
    "greeting.formal.v26": "You are among readers.",
    "greeting.formal.v27": "Welcome back, presumably.",
    "greeting.formal.v28": "Your universe of record stands confirmed.",
    "greeting.formal.v29": "Your universe of record stands confirmed.",
    "greeting.formal.v30": "Good day. It is a news day.",
    "greeting.formal.v31": "You are receiving this correctly.",
    "greeting.formal.v32": "We read you with both eyes open.",
    "greeting.formal.v33": "You are among readers.",
    "greeting.formal.v34": "Good day. It is a news day.",
    "greeting.formal.v35": "Good day. It is a news day.",
    "greeting.formal.v36": "Your universe of record stands confirmed.",
    "greeting.formal.v37": "Your universe of record stands confirmed.",
    "greeting.formal.v38": "The desk acknowledges you.",
    "greeting.formal.v39": "You are receiving this correctly.",
    "greeting.formal.v40": "We read you with both eyes open.",
    "greeting.formal.v41": "The desk acknowledges you.",
    "greeting.formal.v42": "Welcome back, presumably.",
    "greeting.formal.v43": "We read you with both eyes open.",
    "greeting.formal.v44": "We read you with both eyes open.",
    "greeting.formal.v45": "We read you with both eyes open.",
    "greeting.formal.v46": "The paper remembers you fondly.",
    "greeting.formal.v47": "You are among readers.",
    "greeting.formal.v48": "Welcome back, presumably.",
    "greeting.formal.v49": "The paper remembers you fondly.",
    "greeting.formal.v50": "Your universe of record stands confirmed.",
    "greeting.formal.v51": "The paper remembers you fondly.",
    "greeting.formal.v52": "The desk acknowledges you.",
    "greeting.formal.v53": "The paper remembers you fondly.",
    "greeting.formal.v54": "Good day. It is a news day.",
    "greeting.formal.v55": "You are among readers.",
    "greeting.formal.v56": "The desk acknowledges you.",
    "greeting.formal.v57": "The desk acknowledges you.",
    "greeting.formal.v58": "You are among readers.",
    "greeting.formal.v59": "Welcome back, presumably.",
    "greeting.formal.v60": "Your universe of record stands confirmed.",
    "greeting.formal.v61": "The paper remembers you fondly.",
    "greeting.formal.v62": "Your universe of record stands confirmed.",
    "greeting.formal.v63": "We read you with both eyes open.",
    "greeting.formal.v64": "Welcome back, presumably.",
    "greeting.formal.v65": "Welcome back, presumably.",
    "greeting.formal.v66": "The paper remembers you fondly.",
    "greeting.formal.v67": "Welcome back, presumably.",
    "greeting.formal.v68": "The paper remembers you fondly.",
    "greeting.formal.v69": "The desk acknowledges you.",
    "greeting.formal.v70": "Welcome back, presumably.",
    "greeting.formal.v71": "Good day. It is a news day.",
    "greeting.formal.v72": "We read you with both eyes open.",
    "greeting.formal.v73": "Good day. It is a news day.",
    "greeting.formal.v74": "Your universe of record stands confirmed.",
    "greeting.formal.v75": "The desk acknowledges you.",
    "greeting.formal.v76": "You are receiving this correctly.",
    "greeting.formal.v77": "The paper remembers you fondly.",
    "greeting.formal.v78": "We read you with both eyes open.",
    "greeting.formal.v79": "You are receiving this correctly.",
    "greeting.formal.v80": "We read you with both eyes open.",
    "greeting.formal.v81": "The desk acknowledges you.",
    "greeting.formal.v82": "You are among readers.",
    "greeting.formal.v83": "Welcome back, presumably.",
    "greeting.formal.v84": "The desk acknowledges you.",
    "greeting.formal.v85": "We read you with both eyes open.",
    "greeting.formal.v86": "Good day. It is a news day.",
    "greeting.formal.v87": "You are among readers.",
    "greeting.formal.v88": "The paper remembers you fondly.",
    "greeting.formal.v89": "You are among readers.",
    "greeting.formal.v90": "You are among readers.",
    "error.soft.v1": "That failed quietly, as designed.",
    "error.soft.v2": "That failed quietly, as designed.",
    "error.soft.v3": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v4": "The ink smudged. Try again.",
    "error.soft.v5": "Something did not happen. The desk is informed.",
    "error.soft.v6": "That failed quietly, as designed.",
    "error.soft.v7": "The page declined. No feelings involved.",
    "error.soft.v8": "That failed quietly, as designed.",
    "error.soft.v9": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v10": "The page declined. No feelings involved.",
    "error.soft.v11": "Something did not happen. The desk is informed.",
    "error.soft.v12": "That failed quietly, as designed.",
    "error.soft.v13": "That failed quietly, as designed.",
    "error.soft.v14": "The page declined. No feelings involved.",
    "error.soft.v15": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v16": "That failed quietly, as designed.",
    "error.soft.v17": "Something did not happen. The desk is informed.",
    "error.soft.v18": "Something did not happen. The desk is informed.",
    "error.soft.v19": "That failed quietly, as designed.",
    "error.soft.v20": "The page declined. No feelings involved.",
    "error.soft.v21": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v22": "The ink smudged. Try again.",
    "error.soft.v23": "The ink smudged. Try again.",
    "error.soft.v24": "The page declined. No feelings involved.",
    "error.soft.v25": "That failed quietly, as designed.",
    "error.soft.v26": "The page declined. No feelings involved.",
    "error.soft.v27": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v28": "That failed quietly, as designed.",
    "error.soft.v29": "This did not work. It did not work politely.",
    "error.soft.v30": "Something did not happen. The desk is informed.",
    "error.soft.v31": "That failed quietly, as designed.",
    "error.soft.v32": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v33": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v34": "The ink smudged. Try again.",
    "error.soft.v35": "The ink smudged. Try again.",
    "error.soft.v36": "Something did not happen. The desk is informed.",
    "error.soft.v37": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v38": "The page declined. No feelings involved.",
    "error.soft.v39": "That failed quietly, as designed.",
    "error.soft.v40": "The ink smudged. Try again.",
    "error.soft.v41": "Something did not happen. The desk is informed.",
    "error.soft.v42": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v43": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v44": "The page declined. No feelings involved.",
    "error.soft.v45": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v46": "This did not work. It did not work politely.",
    "error.soft.v47": "This did not work. It did not work politely.",
    "error.soft.v48": "Something did not happen. The desk is informed.",
    "error.soft.v49": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v50": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v51": "The ink smudged. Try again.",
    "error.soft.v52": "This did not work. It did not work politely.",
    "error.soft.v53": "The ink smudged. Try again.",
    "error.soft.v54": "That failed quietly, as designed.",
    "error.soft.v55": "This did not work. It did not work politely.",
    "error.soft.v56": "That failed quietly, as designed.",
    "error.soft.v57": "The ink smudged. Try again.",
    "error.soft.v58": "The ink smudged. Try again.",
    "error.soft.v59": "This did not work. It did not work politely.",
    "error.soft.v60": "The ink smudged. Try again.",
    "error.soft.v61": "The page declined. No feelings involved.",
    "error.soft.v62": "The page declined. No feelings involved.",
    "error.soft.v63": "The ink smudged. Try again.",
    "error.soft.v64": "Something did not happen. The desk is informed.",
    "error.soft.v65": "That failed quietly, as designed.",
    "error.soft.v66": "Something did not happen. The desk is informed.",
    "error.soft.v67": "That failed quietly, as designed.",
    "error.soft.v68": "This did not work. It did not work politely.",
    "error.soft.v69": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v70": "Something did not happen. The desk is informed.",
    "error.soft.v71": "The page declined. No feelings involved.",
    "error.soft.v72": "The ink smudged. Try again.",
    "error.soft.v73": "That failed quietly, as designed.",
    "error.soft.v74": "The ink smudged. Try again.",
    "error.soft.v75": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v76": "The ink smudged. Try again.",
    "error.soft.v77": "This did not work. It did not work politely.",
    "error.soft.v78": "The ink smudged. Try again.",
    "error.soft.v79": "The page declined. No feelings involved.",
    "error.soft.v80": "The page declined. No feelings involved.",
    "error.soft.v81": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v82": "The page declined. No feelings involved.",
    "error.soft.v83": "This did not work. It did not work politely.",
    "error.soft.v84": "The ink smudged. Try again.",
    "error.soft.v85": "That failed quietly, as designed.",
    "error.soft.v86": "The page declined. No feelings involved.",
    "error.soft.v87": "Universe mismatch. Expected you elsewhere.",
    "error.soft.v88": "The ink smudged. Try again.",
    "error.soft.v89": "This did not work. It did not work politely.",
    "error.soft.v90": "Something did not happen. The desk is informed.",
    "empty.state.v1": "No entries. Consider writing one.",
    "empty.state.v2": "No entries. Consider writing one.",
    "empty.state.v3": "Blank, but typeset.",
    "empty.state.v4": "No entries. Consider writing one.",
    "empty.state.v5": "Empty, like the print room on Sundays.",
    "empty.state.v6": "Nothing here. The desk is grateful.",
    "empty.state.v7": "Nothing here. The desk is grateful.",
    "empty.state.v8": "No entries. Consider writing one.",
    "empty.state.v9": "Nothing yet. The ferry may be late.",
    "empty.state.v10": "Blank, but typeset.",
    "empty.state.v11": "Empty, like the print room on Sundays.",
    "empty.state.v12": "No entries. Consider writing one.",
    "empty.state.v13": "Blank, but typeset.",
    "empty.state.v14": "Nothing yet. The ferry may be late.",
    "empty.state.v15": "No entries. Consider writing one.",
    "empty.state.v16": "Empty, like the print room on Sundays.",
    "empty.state.v17": "No entries. Consider writing one.",
    "empty.state.v18": "Blank, but typeset.",
    "empty.state.v19": "Empty, like the print room on Sundays.",
    "empty.state.v20": "Nothing here. The desk is grateful.",
    "empty.state.v21": "Empty, like the print room on Sundays.",
    "empty.state.v22": "No entries. Consider writing one.",
    "empty.state.v23": "Nothing yet. The ferry may be late.",
    "empty.state.v24": "No entries. Consider writing one.",
    "empty.state.v25": "Blank, but typeset.",
    "empty.state.v26": "No entries. Consider writing one.",
    "empty.state.v27": "No entries. Consider writing one.",
    "empty.state.v28": "Empty, like the print room on Sundays.",
    "empty.state.v29": "Empty, like the print room on Sundays.",
    "empty.state.v30": "Nothing here. The desk is grateful.",
    "empty.state.v31": "Empty, like the print room on Sundays.",
    "empty.state.v32": "No entries. Consider writing one.",
    "empty.state.v33": "Nothing here. The desk is grateful.",
    "empty.state.v34": "Nothing yet. The ferry may be late.",
    "empty.state.v35": "Blank, but typeset.",
    "empty.state.v36": "Empty, like the print room on Sundays.",
    "empty.state.v37": "No entries. Consider writing one.",
    "empty.state.v38": "Nothing yet. The ferry may be late.",
    "empty.state.v39": "No entries. Consider writing one.",
    "empty.state.v40": "Nothing here. The desk is grateful.",
    "empty.state.v41": "Empty, like the print room on Sundays.",
    "empty.state.v42": "Nothing yet. The ferry may be late.",
    "empty.state.v43": "Nothing yet. The ferry may be late.",
    "empty.state.v44": "Empty, like the print room on Sundays.",
    "empty.state.v45": "Nothing here. The desk is grateful.",
    "empty.state.v46": "Empty, like the print room on Sundays.",
    "empty.state.v47": "No entries. Consider writing one.",
    "empty.state.v48": "Blank, but typeset.",
    "empty.state.v49": "No entries. Consider writing one.",
    "empty.state.v50": "Nothing here. The desk is grateful.",
    "empty.state.v51": "Empty, like the print room on Sundays.",
    "empty.state.v52": "No entries. Consider writing one.",
    "empty.state.v53": "Empty, like the print room on Sundays.",
    "empty.state.v54": "Nothing yet. The ferry may be late.",
    "empty.state.v55": "Nothing yet. The ferry may be late.",
    "empty.state.v56": "Empty, like the print room on Sundays.",
    "empty.state.v57": "Nothing yet. The ferry may be late.",
    "empty.state.v58": "Blank, but typeset.",
    "empty.state.v59": "Nothing yet. The ferry may be late.",
    "empty.state.v60": "Empty, like the print room on Sundays.",
    "empty.state.v61": "No entries. Consider writing one.",
    "empty.state.v62": "No entries. Consider writing one.",
    "empty.state.v63": "Nothing here. The desk is grateful.",
    "empty.state.v64": "Nothing yet. The ferry may be late.",
    "empty.state.v65": "Nothing here. The desk is grateful.",
    "empty.state.v66": "Empty, like the print room on Sundays.",
    "empty.state.v67": "No entries. Consider writing one.",
    "empty.state.v68": "Empty, like the print room on Sundays.",
    "empty.state.v69": "Empty, like the print room on Sundays.",
    "empty.state.v70": "Nothing here. The desk is grateful.",
    "empty.state.v71": "No entries. Consider writing one.",
    "empty.state.v72": "No entries. Consider writing one.",
    "empty.state.v73": "Blank, but typeset.",
    "empty.state.v74": "Nothing yet. The ferry may be late.",
    "empty.state.v75": "Nothing here. The desk is grateful.",
    "confirm.done.v1": "Confirmed twice, for the archive.",
    "confirm.done.v2": "Confirmed. The universe has been told.",
    "confirm.done.v3": "Confirmed twice, for the archive.",
    "confirm.done.v4": "Confirmed and initialled.",
    "confirm.done.v5": "Confirmed. The universe has been told.",
    "confirm.done.v6": "Confirmed twice, for the archive.",
    "confirm.done.v7": "Confirmed twice, for the archive.",
    "confirm.done.v8": "Confirmed and initialled.",
    "confirm.done.v9": "Recorded in both ledgers.",
    "confirm.done.v10": "Confirmed. The universe has been told.",
    "confirm.done.v11": "Recorded in both ledgers.",
    "confirm.done.v12": "Confirmed. You may proceed being right.",
    "confirm.done.v13": "Recorded in both ledgers.",
    "confirm.done.v14": "Recorded in both ledgers.",
    "confirm.done.v15": "Confirmed. You may proceed being right.",
    "confirm.done.v16": "Recorded in both ledgers.",
    "confirm.done.v17": "Confirmed. You may proceed being right.",
    "confirm.done.v18": "Recorded in both ledgers.",
    "confirm.done.v19": "Confirmed. You may proceed being right.",
    "confirm.done.v20": "Confirmed and initialled.",
    "confirm.done.v21": "Confirmed. The universe has been told.",
    "confirm.done.v22": "Confirmed. You may proceed being right.",
    "confirm.done.v23": "Confirmed twice, for the archive.",
    "confirm.done.v24": "Confirmed and initialled.",
    "confirm.done.v25": "Confirmed. The universe has been told.",
    "confirm.done.v26": "Confirmed twice, for the archive.",
    "confirm.done.v27": "Confirmed. You may proceed being right.",
    "confirm.done.v28": "Confirmed. The universe has been told.",
    "confirm.done.v29": "Confirmed and initialled.",
    "confirm.done.v30": "Confirmed. The universe has been told.",
    "confirm.done.v31": "Confirmed twice, for the archive.",
    "confirm.done.v32": "Confirmed. You may proceed being right.",
    "confirm.done.v33": "Recorded in both ledgers.",
    "confirm.done.v34": "Confirmed and initialled.",
    "confirm.done.v35": "Confirmed. You may proceed being right.",
    "confirm.done.v36": "Confirmed twice, for the archive.",
    "confirm.done.v37": "Confirmed. You may proceed being right.",
    "confirm.done.v38": "Confirmed twice, for the archive.",
    "confirm.done.v39": "Confirmed and initialled.",
    "confirm.done.v40": "Confirmed. The universe has been told.",
    "confirm.done.v41": "Confirmed twice, for the archive.",
    "confirm.done.v42": "Confirmed. You may proceed being right.",
    "confirm.done.v43": "Recorded in both ledgers.",
    "confirm.done.v44": "Confirmed. You may proceed being right.",
    "confirm.done.v45": "Confirmed. The universe has been told.",
    "confirm.done.v46": "Confirmed twice, for the archive.",
    "confirm.done.v47": "Confirmed. You may proceed being right.",
    "confirm.done.v48": "Recorded in both ledgers.",
    "confirm.done.v49": "Confirmed twice, for the archive.",
    "confirm.done.v50": "Confirmed twice, for the archive.",
    "confirm.done.v51": "Confirmed. You may proceed being right.",
    "confirm.done.v52": "Recorded in both ledgers.",
    "confirm.done.v53": "Recorded in both ledgers.",
    "confirm.done.v54": "Confirmed. You may proceed being right.",
    "confirm.done.v55": "Confirmed. The universe has been told.",
    "confirm.done.v56": "Confirmed. You may proceed being right.",
    "confirm.done.v57": "Confirmed twice, for the archive.",
    "confirm.done.v58": "Recorded in both ledgers.",
    "confirm.done.v59": "Confirmed. The universe has been told.",
    "confirm.done.v60": "Confirmed. The universe has been told.",
    "confirm.done.v61": "Recorded in both ledgers.",
    "confirm.done.v62": "Confirmed. You may proceed being right.",
    "confirm.done.v63": "Recorded in both ledgers.",
    "confirm.done.v64": "Confirmed and initialled.",
    "confirm.done.v65": "Confirmed twice, for the archive.",
    "confirm.done.v66": "Confirmed twice, for the archive.",
    "confirm.done.v67": "Confirmed. You may proceed being right.",
    "confirm.done.v68": "Recorded in both ledgers.",
    "confirm.done.v69": "Confirmed and initialled.",
    "confirm.done.v70": "Confirmed and initialled.",
    "confirm.done.v71": "Confirmed twice, for the archive.",
    "confirm.done.v72": "Confirmed. You may proceed being right.",
    "confirm.done.v73": "Recorded in both ledgers.",
    "confirm.done.v74": "Confirmed and initialled.",
    "confirm.done.v75": "Recorded in both ledgers.",
    "reader.title.v1": "Capsule witness",
    "reader.title.v2": "Reader",
    "reader.title.v3": "Correspondent",
    "reader.title.v4": "Adjacent reader",
    "reader.title.v5": "Friend of the drawer",
    "reader.title.v6": "Keeper of the ledger",
    "reader.title.v7": "Correspondent",
    "reader.title.v8": "Patron of the print",
    "reader.title.v9": "Adjacent reader",
    "reader.title.v10": "Reader",
    "reader.title.v11": "Patron of the print",
    "reader.title.v12": "Passerby",
    "reader.title.v13": "Correspondent",
    "reader.title.v14": "Patron of the print",
    "reader.title.v15": "Bridge member",
    "reader.title.v16": "Adjacent reader",
    "reader.title.v17": "Bridge member",
    "reader.title.v18": "Bridge member",
    "reader.title.v19": "Adjacent reader",
    "reader.title.v20": "Passerby",
    "reader.title.v21": "Reader",
    "reader.title.v22": "Passerby",
    "reader.title.v23": "Friend of the drawer",
    "reader.title.v24": "Patron of the print",
    "reader.title.v25": "Capsule witness",
    "reader.title.v26": "Keeper of the ledger",
    "reader.title.v27": "Capsule witness",
    "reader.title.v28": "Bridge member",
    "reader.title.v29": "Adjacent reader",
    "reader.title.v30": "Reader",
    "reader.title.v31": "Subscriber",
    "reader.title.v32": "Passerby",
    "reader.title.v33": "Correspondent",
    "reader.title.v34": "Keeper of the ledger",
    "reader.title.v35": "Capsule witness",
    "reader.title.v36": "Adjacent reader",
    "reader.title.v37": "Correspondent",
    "reader.title.v38": "Bridge member",
    "reader.title.v39": "Bridge member",
    "reader.title.v40": "Bridge member",
    "reader.title.v41": "Subscriber",
    "reader.title.v42": "Capsule witness",
    "reader.title.v43": "Bridge member",
    "reader.title.v44": "Bridge member",
    "reader.title.v45": "Friend of the drawer",
    "reader.title.v46": "Bridge member",
    "reader.title.v47": "Capsule witness",
    "reader.title.v48": "Subscriber",
    "reader.title.v49": "Correspondent",
    "reader.title.v50": "Reader",
    "reader.title.v51": "Reader",
    "reader.title.v52": "Passerby",
    "reader.title.v53": "Correspondent",
    "reader.title.v54": "Patron of the print",
    "reader.title.v55": "Friend of the drawer",
    "reader.title.v56": "Patron of the print",
    "reader.title.v57": "Capsule witness",
    "reader.title.v58": "Adjacent reader",
    "reader.title.v59": "Adjacent reader",
    "reader.title.v60": "Friend of the drawer",
    "reader.title.v61": "Passerby",
    "reader.title.v62": "Subscriber",
    "reader.title.v63": "Patron of the print",
    "reader.title.v64": "Subscriber",
    "reader.title.v65": "Friend of the drawer",
    "reader.title.v66": "Subscriber",
    "reader.title.v67": "Capsule witness",
    "reader.title.v68": "Passerby",
    "reader.title.v69": "Bridge member",
    "reader.title.v70": "Patron of the print",
    "reader.title.v71": "Patron of the print",
    "reader.title.v72": "Passerby",
    "reader.title.v73": "Correspondent",
    "reader.title.v74": "Patron of the print",
    "reader.title.v75": "Correspondent",
    "reader.title.v76": "Capsule witness",
    "reader.title.v77": "Keeper of the ledger",
    "reader.title.v78": "Subscriber",
    "reader.title.v79": "Keeper of the ledger",
    "reader.title.v80": "Capsule witness",
    "reader.title.v81": "Subscriber",
    "reader.title.v82": "Passerby",
    "reader.title.v83": "Friend of the drawer",
    "reader.title.v84": "Keeper of the ledger",
    "reader.title.v85": "Adjacent reader",
    "reader.title.v86": "Patron of the print",
    "reader.title.v87": "Keeper of the ledger",
    "reader.title.v88": "Capsule witness",
    "reader.title.v89": "Bridge member",
    "reader.title.v90": "Capsule witness",
    "reader.title.v91": "Adjacent reader",
    "reader.title.v92": "Passerby",
    "reader.title.v93": "Correspondent",
    "reader.title.v94": "Patron of the print",
    "reader.title.v95": "Friend of the drawer",
    "reader.title.v96": "Correspondent",
    "reader.title.v97": "Correspondent",
    "reader.title.v98": "Passerby",
    "reader.title.v99": "Reader",
    "reader.title.v100": "Keeper of the ledger",
    "reader.title.v101": "Subscriber",
    "reader.title.v102": "Friend of the drawer",
    "reader.title.v103": "Bridge member",
    "reader.title.v104": "Passerby",
    "reader.title.v105": "Passerby",
    "signup.title.v1": "Registration, gently",
    "signup.title.v2": "Join us in reading",
    "signup.title.v3": "Join the readership",
    "signup.title.v4": "Become a reader",
    "signup.title.v5": "Free reader registration",
    "signup.title.v6": "Join the readership",
    "signup.title.v7": "Reader record",
    "signup.title.v8": "Join us in reading",
    "signup.title.v9": "The signup",
    "signup.title.v10": "Sign up to keep reading",
    "signup.title.v11": "Registration, gently",
    "signup.title.v12": "Reader record",
    "signup.title.v13": "Join the readership",
    "signup.title.v14": "Join us in reading",
    "signup.title.v15": "Free reader registration",
    "signup.title.v16": "Sign up, simply",
    "signup.title.v17": "Free reader registration",
    "signup.title.v18": "Sign up, simply",
    "signup.title.v19": "The signup",
    "signup.title.v20": "Sign up to keep reading",
    "signup.title.v21": "Sign up to keep reading",
    "signup.title.v22": "Join the readership",
    "signup.title.v23": "Registration, gently",
    "signup.title.v24": "Sign up, simply",
    "signup.title.v25": "Reader record",
    "signup.title.v26": "Sign up, simply",
    "signup.title.v27": "The signup",
    "signup.title.v28": "Join us in reading",
    "signup.title.v29": "The signup",
    "signup.title.v30": "Registration, gently",
    "signup.title.v31": "Reader record",
    "signup.title.v32": "Readers like you",
    "signup.title.v33": "Sign up to keep reading",
    "signup.title.v34": "Become a reader",
    "signup.title.v35": "Free reader registration",
    "signup.title.v36": "Free reader registration",
    "signup.title.v37": "Reader record",
    "signup.title.v38": "Join us in reading",
    "signup.title.v39": "The signup",
    "signup.title.v40": "Join us in reading",
    "signup.title.v41": "Registration, gently",
    "signup.title.v42": "Readers like you",
    "signup.title.v43": "Join the readership",
    "signup.title.v44": "Become a reader",
    "signup.title.v45": "Free reader registration",
    "signup.title.v46": "Join us in reading",
    "signup.title.v47": "Reader record",
    "signup.title.v48": "Registration, gently",
    "signup.title.v49": "Free reader registration",
    "signup.title.v50": "Sign up to keep reading",
    "signup.title.v51": "Become a reader",
    "signup.title.v52": "Sign up to keep reading",
    "signup.title.v53": "Sign up, simply",
    "signup.title.v54": "Free reader registration",
    "signup.title.v55": "Sign up, simply",
    "signup.title.v56": "Sign up, simply",
    "signup.title.v57": "Sign up, simply",
    "signup.title.v58": "Join us in reading",
    "signup.title.v59": "Registration, gently",
    "signup.title.v60": "Registration, gently",
    "signup.title.v61": "Registration, gently",
    "signup.title.v62": "Readers like you",
    "signup.title.v63": "Join us in reading",
    "signup.title.v64": "The signup",
    "signup.title.v65": "Free reader registration",
    "signup.title.v66": "Sign up, simply",
    "signup.title.v67": "Become a reader",
    "signup.title.v68": "Readers like you",
    "signup.title.v69": "Sign up, simply",
    "signup.title.v70": "Sign up to keep reading",
    "signup.title.v71": "Registration, gently",
    "signup.title.v72": "Readers like you",
    "signup.title.v73": "Join the readership",
    "signup.title.v74": "Join the readership",
    "signup.title.v75": "Free reader registration",
    "signup.title.v76": "Sign up, simply",
    "signup.title.v77": "Reader record",
    "signup.title.v78": "Sign up, simply",
    "signup.title.v79": "The signup",
    "signup.title.v80": "Sign up to keep reading",
    "signup.title.v81": "Reader record",
    "signup.title.v82": "Readers like you",
    "signup.title.v83": "Join the readership",
    "signup.title.v84": "Become a reader",
    "signup.title.v85": "The signup",
    "signup.title.v86": "The signup",
    "signup.title.v87": "The signup",
    "signup.title.v88": "Join us in reading",
    "signup.title.v89": "Join the readership",
    "signup.title.v90": "Sign up to keep reading",
    "paywall.line.v1": "Nothing personal. Policy.",
    "paywall.line.v2": "The wall remains a wall.",
    "paywall.line.v3": "The teaser is the free part.",
    "paywall.line.v4": "Subscription pending review.",
    "paywall.line.v5": "Subscription pending review.",
    "paywall.line.v6": "Approval takes time and universes.",
    "paywall.line.v7": "The desk holds the line.",
    "paywall.line.v8": "Approval takes time and universes.",
    "paywall.line.v9": "Nothing personal. Policy.",
    "paywall.line.v10": "The wall remains a wall.",
    "paywall.line.v11": "The wall remains a wall.",
    "paywall.line.v12": "Reviews take universes.",
    "paywall.line.v13": "Reviews take universes.",
    "paywall.line.v14": "Continue behind the desk.",
    "paywall.line.v15": "Reviews take universes.",
    "paywall.line.v16": "The teaser is the free part.",
    "paywall.line.v17": "The desk holds the line.",
    "paywall.line.v18": "Approval takes time and universes.",
    "paywall.line.v19": "Nothing personal. Policy.",
    "paywall.line.v20": "The rest is membership.",
    "paywall.line.v21": "Subscription pending review.",
    "paywall.line.v22": "Reviews take universes.",
    "paywall.line.v23": "The rest is membership.",
    "paywall.line.v24": "Continue behind the desk.",
    "paywall.line.v25": "The rest is membership.",
    "paywall.line.v26": "The wall remains a wall.",
    "paywall.line.v27": "The teaser is the free part.",
    "paywall.line.v28": "Reviews take universes.",
    "paywall.line.v29": "Nothing personal. Policy.",
    "paywall.line.v30": "The wall remains a wall.",
    "paywall.line.v31": "Approval takes time and universes.",
    "paywall.line.v32": "The desk holds the line.",
    "paywall.line.v33": "The teaser is the free part.",
    "paywall.line.v34": "Continue behind the desk.",
    "paywall.line.v35": "Approval takes time and universes.",
    "paywall.line.v36": "Reading beyond costs patience.",
    "paywall.line.v37": "The desk holds the line.",
    "paywall.line.v38": "Approval takes time and universes.",
    "paywall.line.v39": "The rest is membership.",
    "paywall.line.v40": "The teaser is the free part.",
    "paywall.line.v41": "Reading beyond costs patience.",
    "paywall.line.v42": "Reviews take universes.",
    "paywall.line.v43": "The teaser is the free part.",
    "paywall.line.v44": "The rest is membership.",
    "paywall.line.v45": "Subscription pending review.",
    "paywall.line.v46": "Subscription pending review.",
    "paywall.line.v47": "The desk holds the line.",
    "paywall.line.v48": "The teaser is the free part.",
    "paywall.line.v49": "Reading beyond costs patience.",
    "paywall.line.v50": "The desk holds the line.",
    "paywall.line.v51": "Subscription pending review.",
    "paywall.line.v52": "Reviews take universes.",
    "paywall.line.v53": "The teaser is the free part.",
    "paywall.line.v54": "Continue behind the desk.",
    "paywall.line.v55": "The rest is membership.",
    "paywall.line.v56": "Reading beyond costs patience.",
    "paywall.line.v57": "Nothing personal. Policy.",
    "paywall.line.v58": "Approval takes time and universes.",
    "paywall.line.v59": "Nothing personal. Policy.",
    "paywall.line.v60": "Reading beyond costs patience.",
    "paywall.line.v61": "Subscription pending review.",
    "paywall.line.v62": "Reviews take universes.",
    "paywall.line.v63": "The rest is membership.",
    "paywall.line.v64": "Continue behind the desk.",
    "paywall.line.v65": "The wall remains a wall.",
    "paywall.line.v66": "Approval takes time and universes.",
    "paywall.line.v67": "Approval takes time and universes.",
    "paywall.line.v68": "Nothing personal. Policy.",
    "paywall.line.v69": "Nothing personal. Policy.",
    "paywall.line.v70": "The wall remains a wall.",
    "paywall.line.v71": "Reading beyond costs patience.",
    "paywall.line.v72": "The wall remains a wall.",
    "paywall.line.v73": "The rest is membership.",
    "paywall.line.v74": "Nothing personal. Policy.",
    "paywall.line.v75": "The rest is membership.",
    "paywall.line.v76": "Reading beyond costs patience.",
    "paywall.line.v77": "The desk holds the line.",
    "paywall.line.v78": "The teaser is the free part.",
    "paywall.line.v79": "Approval takes time and universes.",
    "paywall.line.v80": "The wall remains a wall.",
    "paywall.line.v81": "The desk holds the line.",
    "paywall.line.v82": "Reviews take universes.",
    "paywall.line.v83": "The teaser is the free part.",
    "paywall.line.v84": "Approval takes time and universes.",
    "paywall.line.v85": "The rest is membership.",
    "paywall.line.v86": "Reading beyond costs patience.",
    "paywall.line.v87": "The rest is membership.",
    "paywall.line.v88": "The rest is membership.",
    "paywall.line.v89": "Nothing personal. Policy.",
    "paywall.line.v90": "The wall remains a wall.",
    "paywall.line.v91": "Subscription pending review.",
    "paywall.line.v92": "Reviews take universes.",
    "paywall.line.v93": "Approval takes time and universes.",
    "paywall.line.v94": "Continue behind the desk.",
    "paywall.line.v95": "Continue behind the desk.",
    "paywall.line.v96": "The rest is membership.",
    "paywall.line.v97": "The wall remains a wall.",
    "paywall.line.v98": "Reviews take universes.",
    "paywall.line.v99": "Continue behind the desk.",
    "paywall.line.v100": "The wall remains a wall.",
    "paywall.line.v101": "Subscription pending review.",
    "paywall.line.v102": "Reviews take universes.",
    "paywall.line.v103": "The teaser is the free part.",
    "paywall.line.v104": "Continue behind the desk.",
    "paywall.line.v105": "The wall remains a wall.",
    "premium.note.v1": "Editors only",
    "premium.note.v2": "The seal is checked first",
    "premium.note.v3": "The dispatch stays sealed",
    "premium.note.v4": "Premium travels sealed",
    "premium.note.v5": "The dispatch stays sealed",
    "premium.note.v6": "The seal is checked first",
    "premium.note.v7": "Not for the wall; for the seal",
    "premium.note.v8": "Authorization is editorial",
    "premium.note.v9": "Authorization is editorial",
    "premium.note.v10": "Not for the wall; for the seal",
    "premium.note.v11": "The reader is ready; the seal is not",
    "premium.note.v12": "Sealed. Truly.",
    "premium.note.v13": "Authorization is editorial",
    "premium.note.v14": "The dispatch stays sealed",
    "premium.note.v15": "The seal is checked first",
    "premium.note.v16": "The reader is ready; the seal is not",
    "premium.note.v17": "Editors only",
    "premium.note.v18": "Not for the wall; for the seal",
    "premium.note.v19": "Authorization is editorial",
    "premium.note.v20": "Sealed dispatch",
    "premium.note.v21": "Editors only",
    "premium.note.v22": "The seal is checked first",
    "premium.note.v23": "Registration does not open it",
    "premium.note.v24": "Premium travels sealed",
    "premium.note.v25": "The dispatch stays sealed",
    "premium.note.v26": "Sealed. Truly.",
    "premium.note.v27": "Not for the wall; for the seal",
    "premium.note.v28": "The reader is ready; the seal is not",
    "premium.note.v29": "Authorization is editorial",
    "premium.note.v30": "Editors only",
    "premium.note.v31": "Editors only",
    "premium.note.v32": "The seal is checked first",
    "premium.note.v33": "Registration does not open it",
    "premium.note.v34": "Sealed dispatch",
    "premium.note.v35": "The dispatch stays sealed",
    "premium.note.v36": "Sealed. Truly.",
    "premium.note.v37": "Not for the wall; for the seal",
    "premium.note.v38": "Sealed. Truly.",
    "premium.note.v39": "Authorization is editorial",
    "premium.note.v40": "Sealed dispatch",
    "premium.note.v41": "Editors only",
    "premium.note.v42": "The seal is checked first",
    "premium.note.v43": "The dispatch stays sealed",
    "premium.note.v44": "Editors only",
    "premium.note.v45": "Not for the wall; for the seal",
    "premium.note.v46": "Sealed. Truly.",
    "premium.note.v47": "Not for the wall; for the seal",
    "premium.note.v48": "The reader is ready; the seal is not",
    "premium.note.v49": "Authorization is editorial",
    "premium.note.v50": "Sealed. Truly.",
    "premium.note.v51": "Editors only",
    "premium.note.v52": "The seal is checked first",
    "premium.note.v53": "Registration does not open it",
    "premium.note.v54": "Editors only",
    "premium.note.v55": "Premium travels sealed",
    "premium.note.v56": "Not for the wall; for the seal",
    "premium.note.v57": "The reader is ready; the seal is not",
    "premium.note.v58": "The reader is ready; the seal is not",
    "premium.note.v59": "Not for the wall; for the seal",
    "premium.note.v60": "Sealed dispatch",
    "premium.note.v61": "Editors only",
    "premium.note.v62": "The seal is checked first",
    "premium.note.v63": "Registration does not open it",
    "premium.note.v64": "Premium travels sealed",
    "premium.note.v65": "The dispatch stays sealed",
    "premium.note.v66": "Sealed. Truly.",
    "premium.note.v67": "Editors only",
    "premium.note.v68": "Registration does not open it",
    "premium.note.v69": "The reader is ready; the seal is not",
    "premium.note.v70": "Sealed dispatch",
    "premium.note.v71": "Editors only",
    "premium.note.v72": "The seal is checked first",
    "premium.note.v73": "Registration does not open it",
    "premium.note.v74": "The dispatch stays sealed",
    "premium.note.v75": "The reader is ready; the seal is not",
    "premium.note.v76": "The seal is checked first",
    "premium.note.v77": "Not for the wall; for the seal",
    "premium.note.v78": "The dispatch stays sealed",
    "premium.note.v79": "The reader is ready; the seal is not",
    "premium.note.v80": "The seal is checked first",
    "premium.note.v81": "Premium travels sealed",
    "premium.note.v82": "Sealed. Truly.",
    "premium.note.v83": "Registration does not open it",
    "premium.note.v84": "Premium travels sealed",
    "premium.note.v85": "The dispatch stays sealed",
    "premium.note.v86": "The seal is checked first",
    "premium.note.v87": "Sealed. Truly.",
    "premium.note.v88": "The reader is ready; the seal is not",
    "premium.note.v89": "Authorization is editorial",
    "premium.note.v90": "Sealed dispatch",
    "mascot.line.v1": "The mascot sends regards.",
    "mascot.line.v2": "Mascot litigation pending.",
    "mascot.line.v3": "The mascot declines.",
    "mascot.line.v4": "The mascot declines.",
    "mascot.line.v5": "Mascot litigation pending.",
    "mascot.line.v6": "The mascot declines.",
    "mascot.line.v7": "The capybara has no comment.",
    "mascot.line.v8": "The capybara has no comment.",
    "mascot.line.v9": "Two pigeons were consulted.",
    "mascot.line.v10": "Two pigeons were consulted.",
    "mascot.line.v11": "The mascot sends regards.",
    "mascot.line.v12": "Mascot unavailable for comment.",
    "mascot.line.v13": "The duck is not the duck.",
    "mascot.line.v14": "Two pigeons were consulted.",
    "mascot.line.v15": "The duck is not the duck.",
    "mascot.line.v16": "Two pigeons were consulted.",
    "mascot.line.v17": "Mascot hours: never",
    "mascot.line.v18": "The capybara has no comment.",
    "mascot.line.v19": "Two pigeons were consulted.",
    "mascot.line.v20": "The duck is not the duck.",
    "mascot.line.v21": "The duck is not the duck.",
    "mascot.line.v22": "Mascot unavailable for comment.",
    "mascot.line.v23": "The mascot declines.",
    "mascot.line.v24": "Two pigeons were consulted.",
    "mascot.line.v25": "The duck is not the duck.",
    "mascot.line.v26": "The mascot sends regards.",
    "mascot.line.v27": "The capybara has no comment.",
    "mascot.line.v28": "The capybara has no comment.",
    "mascot.line.v29": "Mascot litigation pending.",
    "mascot.line.v30": "The mascot is fine.",
    "mascot.line.v31": "The heron abstained.",
    "mascot.line.v32": "Mascot unavailable for comment.",
    "mascot.line.v33": "The duck is not the duck.",
    "mascot.line.v34": "Mascot litigation pending.",
    "mascot.line.v35": "The mascot declines.",
    "mascot.line.v36": "The capybara has no comment.",
    "mascot.line.v37": "Mascot hours: never",
    "mascot.line.v38": "The capybara has no comment.",
    "mascot.line.v39": "Mascot hours: never",
    "mascot.line.v40": "The mascot is fine.",
    "mascot.line.v41": "The mascot declines.",
    "mascot.line.v42": "The mascot declines.",
    "mascot.line.v43": "The mascot sends regards.",
    "mascot.line.v44": "The mascot sends regards.",
    "mascot.line.v45": "The mascot is fine.",
    "mascot.line.v46": "The capybara has no comment.",
    "mascot.line.v47": "The mascot declines.",
    "mascot.line.v48": "The capybara has no comment.",
    "mascot.line.v49": "The mascot is fine.",
    "mascot.line.v50": "Mascot litigation pending.",
    "mascot.line.v51": "The mascot sends regards.",
    "mascot.line.v52": "Two pigeons were consulted.",
    "mascot.line.v53": "Mascot unavailable for comment.",
    "mascot.line.v54": "Mascot litigation pending.",
    "mascot.line.v55": "The duck is not the duck.",
    "mascot.line.v56": "Two pigeons were consulted.",
    "mascot.line.v57": "The heron abstained.",
    "mascot.line.v58": "The heron abstained.",
    "mascot.line.v59": "Mascot hours: never",
    "mascot.line.v60": "The mascot is fine.",
    "mascot.line.v61": "The mascot sends regards.",
    "mascot.line.v62": "Mascot unavailable for comment.",
    "mascot.line.v63": "The mascot sends regards.",
    "mascot.line.v64": "Mascot litigation pending.",
    "mascot.line.v65": "The mascot is fine.",
    "mascot.line.v66": "Mascot hours: never",
    "mascot.line.v67": "The mascot declines.",
    "mascot.line.v68": "The capybara has no comment.",
    "mascot.line.v69": "Mascot hours: never",
    "mascot.line.v70": "The mascot sends regards.",
    "mascot.line.v71": "The capybara has no comment.",
    "mascot.line.v72": "Mascot unavailable for comment.",
    "mascot.line.v73": "The mascot declines.",
    "mascot.line.v74": "Mascot litigation pending.",
    "mascot.line.v75": "The mascot declines.",
    "mascot.line.v76": "Two pigeons were consulted.",
    "mascot.line.v77": "The heron abstained.",
    "mascot.line.v78": "The capybara has no comment.",
    "mascot.line.v79": "The mascot is fine.",
    "mascot.line.v80": "The mascot is fine.",
    "mascot.line.v81": "Two pigeons were consulted.",
    "mascot.line.v82": "Mascot unavailable for comment.",
    "mascot.line.v83": "The mascot declines.",
    "mascot.line.v84": "Mascot hours: never",
    "mascot.line.v85": "The duck is not the duck.",
    "mascot.line.v86": "Mascot unavailable for comment.",
    "mascot.line.v87": "The heron abstained.",
    "mascot.line.v88": "The capybara has no comment.",
    "mascot.line.v89": "The mascot is fine.",
    "mascot.line.v90": "The mascot is fine.",
    "bridge.line.v1": "The bridge is closed for paper.",
    "bridge.line.v2": "Mind the corridor.",
    "bridge.line.v3": "Crossing counted",
    "bridge.line.v4": "Return crossing free",
    "bridge.line.v5": "The ferry precedes the bridge.",
    "bridge.line.v6": "The bridge tilts, politely",
    "bridge.line.v7": "The bridge observes silence",
    "bridge.line.v8": "The bridge tilts, politely",
    "bridge.line.v9": "Crossing counted",
    "bridge.line.v10": "The bridge is open.",
    "bridge.line.v11": "Crossing counted",
    "bridge.line.v12": "Mind the corridor.",
    "bridge.line.v13": "The ferry precedes the bridge.",
    "bridge.line.v14": "Bridge hours: tidal",
    "bridge.line.v15": "The bridge observes silence",
    "bridge.line.v16": "The bridge is open.",
    "bridge.line.v17": "Return crossing free",
    "bridge.line.v18": "The bridge is closed for paper.",
    "bridge.line.v19": "The bridge is open.",
    "bridge.line.v20": "The bridge is open.",
    "bridge.line.v21": "Return crossing free",
    "bridge.line.v22": "Mind the corridor.",
    "bridge.line.v23": "Mind the corridor.",
    "bridge.line.v24": "The bridge is open.",
    "bridge.line.v25": "The bridge is closed for paper.",
    "bridge.line.v26": "Bridge hours: tidal",
    "bridge.line.v27": "Mind the corridor.",
    "bridge.line.v28": "Bridge hours: tidal",
    "bridge.line.v29": "Bridge hours: tidal",
    "bridge.line.v30": "Mind the other side",
    "bridge.line.v31": "Bridge hours: tidal",
    "bridge.line.v32": "The bridge is open.",
    "bridge.line.v33": "The ferry precedes the bridge.",
    "bridge.line.v34": "Bridge hours: tidal",
    "bridge.line.v35": "The bridge observes silence",
    "bridge.line.v36": "The bridge tilts, politely",
    "bridge.line.v37": "Bridge hours: tidal",
    "bridge.line.v38": "Mind the corridor.",
    "bridge.line.v39": "The bridge tilts, politely",
    "bridge.line.v40": "Mind the corridor.",
    "bridge.line.v41": "The bridge observes silence",
    "bridge.line.v42": "The bridge observes silence",
    "bridge.line.v43": "Bridge hours: tidal",
    "bridge.line.v44": "The bridge is open.",
    "bridge.line.v45": "The ferry precedes the bridge.",
    "bridge.line.v46": "Crossing counted",
    "bridge.line.v47": "The ferry precedes the bridge.",
    "bridge.line.v48": "The bridge tilts, politely",
    "bridge.line.v49": "Mind the other side",
    "bridge.line.v50": "The bridge observes silence",
    "bridge.line.v51": "The bridge is closed for paper.",
    "bridge.line.v52": "The bridge is closed for paper.",
    "bridge.line.v53": "The bridge is open.",
    "bridge.line.v54": "Mind the other side",
    "bridge.line.v55": "The bridge is closed for paper.",
    "bridge.line.v56": "The bridge is closed for paper.",
    "bridge.line.v57": "Mind the other side",
    "bridge.line.v58": "The bridge is open.",
    "bridge.line.v59": "The bridge is open.",
    "bridge.line.v60": "The bridge is open.",
    "bridge.line.v61": "The bridge is closed for paper.",
    "bridge.line.v62": "Mind the corridor.",
    "bridge.line.v63": "The bridge is open.",
    "bridge.line.v64": "Bridge hours: tidal",
    "bridge.line.v65": "The bridge observes silence",
    "bridge.line.v66": "Crossing counted",
    "bridge.line.v67": "Return crossing free",
    "bridge.line.v68": "The bridge tilts, politely",
    "bridge.line.v69": "Mind the other side",
    "bridge.line.v70": "The bridge is open.",
    "bridge.line.v71": "Mind the corridor.",
    "bridge.line.v72": "Mind the corridor.",
    "bridge.line.v73": "Mind the corridor.",
    "bridge.line.v74": "Bridge hours: tidal",
    "bridge.line.v75": "Bridge hours: tidal",
    "archive.line.v1": "The archive locks for symmetry.",
    "archive.line.v2": "Retired plates rest here.",
    "archive.line.v3": "Ask the plate ledger.",
    "archive.line.v4": "Older news, same ink.",
    "archive.line.v5": "Dust is a feature.",
    "archive.line.v6": "Bound volumes, roughly bound.",
    "archive.line.v7": "The archive remembers so you choose not to.",
    "archive.line.v8": "Older editions live here.",
    "archive.line.v9": "Older news, same ink.",
    "archive.line.v10": "Dust is a feature.",
    "archive.line.v11": "Ask the plate ledger.",
    "archive.line.v12": "Older news, same ink.",
    "archive.line.v13": "Ask the plate ledger.",
    "archive.line.v14": "Bound volumes, roughly bound.",
    "archive.line.v15": "Retired plates rest here.",
    "archive.line.v16": "Older editions live here.",
    "archive.line.v17": "The archive locks for symmetry.",
    "archive.line.v18": "Older editions live here.",
    "archive.line.v19": "Dust is a feature.",
    "archive.line.v20": "Older news, same ink.",
    "archive.line.v21": "Older editions live here.",
    "archive.line.v22": "Bound volumes, roughly bound.",
    "archive.line.v23": "Bound volumes, roughly bound.",
    "archive.line.v24": "The archive remembers so you choose not to.",
    "archive.line.v25": "The archive locks for symmetry.",
    "archive.line.v26": "Dust is a feature.",
    "archive.line.v27": "Ask the plate ledger.",
    "archive.line.v28": "Older news, same ink.",
    "archive.line.v29": "The archive remembers so you choose not to.",
    "archive.line.v30": "Bound volumes, roughly bound.",
    "archive.line.v31": "The archive remembers so you choose not to.",
    "archive.line.v32": "Older editions live here.",
    "archive.line.v33": "The archive locks for symmetry.",
    "archive.line.v34": "Dust is a feature.",
    "archive.line.v35": "Ask the plate ledger.",
    "archive.line.v36": "Older news, same ink.",
    "archive.line.v37": "The archive remembers so you choose not to.",
    "archive.line.v38": "Bound volumes, roughly bound.",
    "archive.line.v39": "Older editions live here.",
    "archive.line.v40": "Older editions live here.",
    "archive.line.v41": "Retired plates rest here.",
    "archive.line.v42": "Dust is a feature.",
    "archive.line.v43": "Bound volumes, roughly bound.",
    "archive.line.v44": "Older news, same ink.",
    "archive.line.v45": "Dust is a feature.",
    "archive.line.v46": "Bound volumes, roughly bound.",
    "archive.line.v47": "The archive remembers so you choose not to.",
    "archive.line.v48": "The archive locks for symmetry.",
    "archive.line.v49": "The archive locks for symmetry.",
    "archive.line.v50": "The archive locks for symmetry.",
    "archive.line.v51": "Bound volumes, roughly bound.",
    "archive.line.v52": "Older news, same ink.",
    "archive.line.v53": "Older editions live here.",
    "archive.line.v54": "Older editions live here.",
    "archive.line.v55": "Older news, same ink.",
    "archive.line.v56": "Older editions live here.",
    "archive.line.v57": "The archive remembers so you choose not to.",
    "archive.line.v58": "Dust is a feature.",
    "archive.line.v59": "The archive remembers so you choose not to.",
    "archive.line.v60": "The archive remembers so you choose not to.",
    "archive.line.v61": "Ask the plate ledger.",
    "archive.line.v62": "Bound volumes, roughly bound.",
    "archive.line.v63": "The archive locks for symmetry.",
    "archive.line.v64": "Older editions live here.",
    "archive.line.v65": "The archive locks for symmetry.",
    "archive.line.v66": "Ask the plate ledger.",
    "archive.line.v67": "Ask the plate ledger.",
    "archive.line.v68": "The archive locks for symmetry.",
    "archive.line.v69": "The archive remembers so you choose not to.",
    "archive.line.v70": "Bound volumes, roughly bound.",
    "archive.line.v71": "Ask the plate ledger.",
    "archive.line.v72": "Older editions live here.",
    "archive.line.v73": "The archive locks for symmetry.",
    "archive.line.v74": "Dust is a feature.",
    "archive.line.v75": "Ask the plate ledger.",
    "section.name.0": "Front",
    "section.name.1": "Bureaus",
    "section.name.2": "Multiverse",
    "section.name.3": "Corrections",
    "section.name.4": "Weather (all)",
    "section.name.5": "Ferry desk",
    "section.name.6": "Archive",
    "section.name.7": "Print",
    "reader.greeting.formal": "746fe8219f2eee77cef9040766d589a6"
  }
}
